import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import GPSCoordinates from "../../../../models/GPSCoordinates";
import DisplayLatLong from "../../../display/DisplayLatLong";
import MissingField from "../MissingField";
import ValidationItem from "../ValidationItem";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    localisation?: GPSCoordinates
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 04/07/2022
 * @last_update 04/07/2022
 **/
class Localisation extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <ValidationItem label={getTranslation("steps.validation.labels.localisation")}>
                {
                    this.props.localisation ? <DisplayLatLong geolocation={this.props.localisation}/> : <MissingField/>
                }
            </ValidationItem>

        );

    };

}

export default withTranslation()(Localisation);
